export default class ModuleBase {
    constructor(el) {
        this.$el = el;
        this.$refs = this._collectReferences();
    }

    _collectReferences() {
        const refs = {};
        const collectedReferences = [];
        this.$el.querySelectorAll('[data-ref]').forEach((el) => {
            if (el.dataset.refScope === 'all-parents' || el.closest('[data-module]') === this.$el) {
                collectedReferences.push(el);
            }
        });

        collectedReferences.forEach((el) => {
            const referenceName = el.dataset.ref;
            if (referenceName.endsWith('[]')) {
                const refName = referenceName.slice(0, -2);
                if (refs[refName]) {
                    refs[refName].push(el);
                } else {
                    refs[refName] = [el];
                }
            } else {
                refs[referenceName] = el;
            }
        });
        return refs;
    }
}
